import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import ImageLink from '../../js/utils/ImageLink';
import { formatDate } from '../../js/utils/format-date';
import stripMarkdown from '../../js/utils/strip-markdown';
import LocaleContext from '../../contexts/LocaleContext';
/**
 *
 * @param {{image: image, title: string, subtitle?: string, body?: string, date: string, author: string, url: string}} props
 * @returns
 */

export default function ArticleCard({ image, title, subtitle, body, date, author, url }) {
  const { locale } = useContext(LocaleContext);
  const { t } = useTranslation(['HomePage']);
  const bodyPreview = stripMarkdown(body);

  const Wrapper = url ? 'a' : 'div';
  const wrapperProps = url ? { href: url, target: '_blank', rel: 'noopener noreferrer' } : {};

  return (
    <div className="article-card">
      <Wrapper {...wrapperProps}>
        <div className="article-card__media">
          <img src={ImageLink(image.url)} alt={image.alt} />
        </div>

        <p className="article-card__date">
          {formatDate(date, locale === 'en' ? 'en-US' : 'ar-EG')}
        </p>
        <p className="article-card__title">{title}</p>
        {subtitle && <p className="article-card__subtitle">{subtitle}</p>}
        {bodyPreview && <p className="article-card__body">{bodyPreview}</p>}
        <p className="article-card__author">
          {t('by')} {author}
        </p>
      </Wrapper>
    </div>
  );
}
